<template>
    <div>
        <el-dialog id="ipKeywordsSearchModel" title="关键词检索" :visible.sync="dialogVisible" :width="width" @close="closeDialog" :close-on-click-modal="false">
                <div class="modal-body">
                      <el-form label-width="100px" label-position="left" size="mini" @submit.native.prevent>
                            <el-row>
                                <el-col :span="24" style="padding-bottom: 10px;">
                                    <div v-if="!!showError.isShow">
                                        <el-alert :title="showError.message" type="warning" show-icon @close="showError.isShow = false"></el-alert>
                                    </div>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="搜索关键词：">
                                        <el-input size="mini" v-model="keywordQuery" @keyup.enter.native="searchKeyword">
                                            <el-button slot="append" icon="el-icon-search" type="primary" @click="searchKeyword"></el-button>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <h3>专业术语资源库查询结果</h3>
                            <el-row :gutter="20">
                                <el-col :span="5">
                                    <el-select v-model="selectedKeywordType" placeholder="请选择" size="mini">
                                        <el-option
                                                v-for="item in keywordType"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="19">
                                    <div class="result-container">
                                        <template v-for="item in queryResult[selectedKeywordType]">
                                              <el-checkbox v-model="item.checked" @change="whenCheckItem"></el-checkbox>
                                                {{item.name}}
                                        </template>
                                        <template v-if="queryResult[selectedKeywordType] && queryResult[selectedKeywordType].length === 0">
                                                没有找到相关结果
                                        </template>
                                    </div>
                                </el-col>
                            </el-row>
                            <h3>已选择关键词</h3>
                            <el-row>
                                <div class="result-container">
                                    <el-tag v-for="tag in selectedOption" closable :disable-transitions="false"
                                            size="small" @close="deleteSelected(tag.name,tag.type)">
                                        {{tag.name}}
                                    </el-tag>
                                </div>
                            </el-row>
                      </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="clearDialog">清除</el-button>
                    <el-button size="small" type="primary" @click="generateExp">生成表达式</el-button>
			    </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
     name:'ipKeywordsSearchModel',
     props:{
            visible: {type: Boolean,default: false},
            width:{type: String,default: ''},
            queryResult:{type:Object,default(){return {}}},
            showError:{type:Object,default(){return {}}},
     },
     data(){
         return{
             keywordQuery:'',
             keywordType:[{value:'headword',label:'中心词'},
                        {value:'hypernym',label:'上位词'},
                        {value:'hyponym',label:'下位词'},
                        {value:'thesaurus',label:'同义词'},
                        {value:'chemicalFormula',label:'化学式'},
                        {value:'relatedTerm',label:'相关词'},
                        {value:'domain',label:'领域'},
                        {value:'ipc',label:'IPC'},
                        {value:'englishWord',label:'英文词'},
                        {value:'abbreviate',label:'缩写'},
                        {value:'cas',label:'CAS'}],
            selectedKeywordType:'headword',
            selectedOption:[]
         }
     },
    computed:{
        dialogVisible:{
            get(){return this.visible},
            set(){}
        }
    },
     methods:{
        searchKeyword(){
            this.$emit('keywordSearch',this.keywordQuery);
        },
        clearDialog(){
            this.keywordQuery = '';
            this.selectedOption = [];
            this.$emit('clearDialog');
        },
        generateExp(){
            this.$emit('generateExp',this.selectedOption);
        },
        closeDialog(){
            this.$emit('closeDialog');
        },
        deleteSelected(name,type){
            const self = this;
            self.selectedOption.forEach(function(item,index){
                if(item.name === name){
                    self.selectedOption.splice(index,1);
                }
            })
            this.$emit('deleteSelectedKeyword',{name:name,type:type});
        },
        whenCheckItem(){
            const self = this;
            self.selectedOption = [];
            Object.keys(this.queryResult).forEach(function(item){
                if(!!self.queryResult[item]){
                    self.queryResult[item].forEach(function(e){
                        if(e.checked){
                            self.selectedOption.push({'name':e.name,'type':item});
                        }
                    })
            }
            });
        }
     }
}
</script>
<style lang="scss">
#ipKeywordsSearchModel {
    .el-col{
        margin-top: 0;
    }
    .el-dialog__body{
        padding: 15px 20px;
    }
    .el-dialog__header {
        background: $theme-color;
        height: 40px;
        line-height: 40px;
        padding: 0px 15px;
        box-sizing: border-box;
        .el-dialog__title{
            font-size: 16px;
            color: #ffffff;
        }
        .el-dialog__headerbtn{
            top: 12px;
            .el-dialog__close{
                color: #ffffff;
            }
        }
    }
    .el-form-item{
        margin-bottom: 5px;
    }
}
</style>
<style lang="scss" scoped>
#ipKeywordsSearchModel{
    h3{
        font-size:14px;
        font-weight:normal;
        color:#1f2f3d;
        margin:14px 0;
    }
    .result-container{
      border:1px solid #dcdfe6;
      padding: 5px 10px;
      min-height: 100px;
      .el-tag{
        margin: 0 10px 10px 0;
      }
    }
}
</style>
